import React, { useContext, useEffect } from 'react'
import emojiStrip from 'emoji-strip'

import { EngravingContext } from 'components/buy/Engraving/EngravingContext'
import Heading from 'components/buy/Engraving/Heading'
import Input from 'components/Input'
import MobileBack from 'components/buy/Engraving/MobileBack'

const EngravingBox = () => {
  const { engraving, setEngraving, currentView, setCurrentView, textError } = useContext(EngravingContext)

  useEffect(() => {
    if (currentView?.item !== 'box') {
      setCurrentView({ ...currentView, item: 'box', step: 'text' })
    }
  }, [currentView, setCurrentView])

  return (
    <>
      <Heading
        number="03"
        title="Make it yours"
        description="Get a custom box, personalized for you"
        mobileBack={() => (
          <MobileBack
            onClick={() => {
              setEngraving({
                ...engraving,
                back: {
                  ...engraving.back,
                  proceeded: false
                }
              })
              setCurrentView({ item: 'back', step: 'initialstep' })
            }}
          />
        )}
      />
      <Input
        label="Tell us your first name"
        name="text"
        type="text"
        value={engraving.box.text.value}
        onChange={e => {
          setEngraving({
            ...engraving,
            box: {
              ...engraving.box,
              text: {
                ...engraving.box.text,
                value: emojiStrip(e.target.value)
              }
            }
          })
        }}
        hint={`It's not for you? Enter your recipient's first name`}
        maxLength={20}
        meta={{
          error: textError,
          touched: textError.length > 0
        }}
        placeholder={`NAME'S ePod`}
      />
    </>
  )
}

export default EngravingBox
